import React from 'react';

const ProblemSection: React.FC = () => {
  const problems = [
    {
      icon: '⏰',
      title: '시간 낭비',
      description: '30분 영상, 핵심은 2분',
      color: 'from-red-500 to-pink-500',
      bgColor: 'bg-red-50',
      iconBg: 'bg-red-100'
    },
    {
      icon: '🔄',
      title: '알고리즘 함정',
      description: '늘 비슷한 추천 콘텐츠',
      color: 'from-orange-500 to-red-500',
      bgColor: 'bg-orange-50',
      iconBg: 'bg-orange-100'
    },
    {
      icon: '📅',
      title: '뒤늦은 발견',
      description: '이미 대세가 바뀌었다고?',
      color: 'from-yellow-500 to-orange-500',
      bgColor: 'bg-yellow-50',
      iconBg: 'bg-yellow-100'
    },
    {
      icon: '🌐',
      title: '언어 장벽',
      description: '국외 커뮤니티는 영어라...',
      color: 'from-blue-500 to-purple-500',
      bgColor: 'bg-blue-50',
      iconBg: 'bg-blue-100'
    }
  ];

  return (
    <section className="py-24 px-4 bg-gradient-to-br from-gray-50 to-gray-100 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23000000' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 mb-8 bg-gradient-to-r from-red-500 to-pink-500 text-white rounded-full text-sm font-semibold shadow-lg">
            <span className="w-2 h-2 bg-white rounded-full mr-2 animate-pulse"></span>
            ⚠️ 문제점 분석
          </div>
          
          <h2 className="text-5xl md:text-6xl font-black mb-8">
            <span className="bg-gradient-to-r from-red-600 to-pink-600 bg-clip-text text-transparent">
              AI 정보
            </span>
            <br />
            <span className="text-gray-800">이래서 놓칩니다</span>
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            매일 수많은 AI 정보에 파묻혀 있지만, 정작 중요한 것은 놓치고 있지 않나요?
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {problems.map((problem, index) => (
            <div 
              key={index} 
              className={`${problem.bgColor} p-8 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-white/50 backdrop-blur-sm relative overflow-hidden group`}
            >
              {/* Hover Effect */}
              <div className={`absolute inset-0 bg-gradient-to-br ${problem.color} opacity-0 group-hover:opacity-10 transition-opacity duration-500`}></div>
              
              <div className="relative z-10 text-center">
                <div className={`${problem.iconBg} w-20 h-20 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <span className="text-3xl">{problem.icon}</span>
                </div>
                
                <h3 className="text-2xl font-bold mb-4 text-gray-800 group-hover:text-gray-900 transition-colors">
                  {problem.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed text-lg group-hover:text-gray-700 transition-colors">
                  {problem.description}
                </p>
                
                {/* Decorative Element */}
                <div className={`absolute top-4 right-4 w-8 h-8 bg-gradient-to-br ${problem.color} rounded-full opacity-20 group-hover:opacity-40 transition-opacity duration-300`}></div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-gray-800 to-gray-900 text-white rounded-2xl shadow-lg">
            <span className="text-2xl mr-3">😤</span>
            <span className="text-lg font-semibold">이런 문제들, 이제 그만!</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
